export const useProductMenuStore = defineStore("productMenu", {
  state: () => ({
    hasSpecifications: false,
    hasGeometries: false,
    hasManuals: false,
  }),

  actions: {
    statusSpecifications(status) {
      this.hasSpecifications = status;
    },
    statusGeometries(status) {
      this.hasGeometries = status;
    },
    statusManuals(status) {
      this.hasManuals = status;
    },
  },

  getters: {
    getSpecifications(state) {
      return state.hasSpecifications;
    },
    getGeometries(state) {
      return state.hasGeometries;
    },
    getManuals(state) {
      return state.hasManuals;
    },
  },
});